<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>
<script>
import {CDB_JWT_ACCESS_TOKEN, CHECK_RELOAD, SUCCESS} from './common/constants'
import store from './store'
export default {
  name: 'App',
  data () {
    return {
      getToken: false
    }
  },
  mounted () {
    // window.addEventListener('message', this.getInfo)
  },
  methods: {
    getInfo (event) {
      if (!this.getToken) {
        this.getToken = true
        sessionStorage.setItem(CDB_JWT_ACCESS_TOKEN, event.data.message)
        if (store.state.auth_status !== SUCCESS && !sessionStorage.getItem(CHECK_RELOAD)) {
          window.location.reload()
        }
        sessionStorage.setItem(CHECK_RELOAD, true)
      }
    }
  },
  destroyed () {
    window.removeEventListener('message', this.getInfo)
  }
}
</script>

<style>
#app {
  background: #f5f5f5;
  overflow: hidden;
  width: 100%;
  margin: auto;
}

.v-list .v-list-item .v-list-item__action {
  margin : 0px 8px 0px 0px !important;
  margin-right: 8px;
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue